export const isStatement = s => s.type === "statement" || s.type === "member";
export const isInputAction = s =>
  s.type === "input_action" ||
    s.type === "extra_question" ||
    s.type === "action_note" ||
  s.type === "response_history" ||
  s.type === "submit_buttons";
export const isTrendValue = s => s.type === "trend_values";
